import { render, staticRenderFns } from "./SettingsTypeModal.vue?vue&type=template&id=0acc14fa&lang=pug&"
import script from "./SettingsTypeModal.vue?vue&type=script&lang=js&"
export * from "./SettingsTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports